import store from '@/stores/store';
import axios from '@/plugins/axios';
import utils from '@/stores/utils';
import billingaccounts from './submodules/billingaccounts';
import catalogs from './submodules/catalogs';
import stocks from './submodules/stocks';
import catalog from '@/mixins/catalog';

const state = {
    customer: null,
    customer_saving: false,
    customer_saving_errors: {},

    allowed_stocks: [],
    allowed_catalogs: [],

    delivery_address_same_as_billing: true,
    ready: false,
};

const mutations = {
    updateCustomer(state, customer) {
        state.customer = customer;
    },
    updateCustomerSaving(state, saving) {
        state.customer_saving = saving;
    },
    updateCustomerSavingErrors(state, errors) {
        state.customer_saving_errors = errors;
    },

    updateAllowedCatalogs(state, catalogs) {
        state.allowed_catalogs = catalogs;
    },
    updateReady(state, ready) {
        state.ready = ready;
    }

};

const actions = {

    async assignCatalogs({ commit, dispatch, state }) {
        if (!state.customer?.id) {
            throw new Error("Customer is required to assign catalogs");
        }
        commit('updateCustomerSaving', true);

        try {
            const response = await axios.post(`/api/customers/${state.customer.id}/catalogs/`, { catalogs: state.allowed_catalogs });
            commit('updateCustomerSaving', false);
            dispatch('session/fetchStats', null, { root: true });
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateCustomerSavingErrors', error.details);
            commit('updateCustomerSaving', false);
            throw error;
        }
    },

    async assignDefaultCatalogs({ commit, dispatch }) {
        await dispatch('defaultcatalogs/init', {
            filters: { limit: 1000, type: 'sell', default: true },
        });
        await dispatch('defaultcatalogs/fetchCatalogs');
        commit('updateAllowedCatalogs', state.defaultcatalogs.catalogs.map((catalog) => catalog.id));
    },

    async init({ commit, dispatch, state }, params) {
        await commit('updateCustomerSavingErrors', {});
        await commit('updateCustomer', params.customer ?? null);
        if (!params.customer?.id) {
            await commit('updateReady', false);
            return;
        }
        await dispatch('catalogs/init', {
            filters: { limit: 20, offset: 0, assignment_customer: params.customer.id, ordering: 'owner_name', type: 'sell' },
        });
        await dispatch('catalogs/fetchCatalogs');
        await commit('updateAllowedCatalogs', []);

        if (params.assign_defaults) {
            await dispatch('assignDefaultCatalogs');
            await commit('updateReady', true);
        } else {
            // Check if customer already has catalogs assigned
            if (state.customer && state.customer.catalogs && Array.isArray(state.customer.catalogs) && state.customer.catalogs.length > 0) {
                // Use catalogs from customer object if available
                await commit('updateAllowedCatalogs', state.customer.catalogs);
                await commit('updateReady', true);
            } else {
                // Use assignment_customer filter to get catalogs with allowed flag
                await dispatch('allowedcatalogs/init', {
                    filters: { limit: 1000, assignment_customer: params.customer.id, type: 'sell' },
                });
                await dispatch('allowedcatalogs/fetchCatalogs');
                // Filter catalogs to only include those with allowed=true
                const assignedCatalogs = state.allowedcatalogs.catalogs
                    .filter((catalog) => catalog.allowed === true)
                    .map((catalog) => catalog.id);
                await commit('updateAllowedCatalogs', assignedCatalogs);
                await commit('updateReady', true);
            }
        }
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        catalogs: catalogs(),
        allowedcatalogs: catalogs(),
        defaultcatalogs: catalogs(),
    }
};